import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock';

export default {
  methods: {
    toggleSideMenu(reference) {
      this.$refs[reference].open = !this.$refs[reference].open

      if (this.$refs[reference].open) {
        disableBodyScroll(this.$refs[reference].$refs['target'], {
          reserveScrollBarGap: false,
        })
      } else {
        enableBodyScroll(this.$refs[reference].$refs['target'], {
          reserveScrollBarGap: false
        })
      }
    },
    closeSideMenu(reference) {
      this.$refs[reference].open = false;

      enableBodyScroll(this.$refs[reference].$refs['target'], {
        reserveScrollBarGap: false
      })
    },
    openSideMenu(reference) {
      this.$refs[reference].open = true;
    }
  }
}